import * as ACTION from './constants';

const initialState = {
  isSubmitting: false,
  form: null,
  clean: true,
  exercises: [],
};

export default function reducers(state = initialState, action) {
  switch(action.type) {
    case ACTION.FORM_BASE:
      return {...initialState};
    case ACTION.FORM_SUBMITTING:
      //action.form.checkValidity();
      return {...state,
        isSubmitting: true
      };
    case ACTION.FORM_SUBMITTED:
      return {...state,
        isSubmitting: false,
      };
    case ACTION.FORM_SET:
      //action.form.checkValidity();
      return {...state,
        form: action.form,
        clean: action.initial
      };
    case ACTION.UPDATE_SETS_VIDEO:
      //action.form.checkValidity();
      return {
        ...state,
        form: {
          ...state.form,
          sets: state.form.sets.map(set => {
            if(set.id === action.item.setId) {
              if(action.item.videoBefore){
                return {...set, video_before: {...action.item.videoData}}
              } else {
                return {...set, video_after: {...action.item.videoData}}
              }
            } else {
              return set
            }
          }),
          checkValidity: state.form.checkValidity
        }
      };
    default:
      return state;
  }
}
